import React from "react";
import NotificationsMenu from "./NotificationsMenu";
import "./common.css";
import { Bell } from "lucide-react";
interface AnnouncementProps {
  isNotificationsOpen: boolean;
  toggleNotifications: (e: React.MouseEvent) => void;
  unReadCount: number;
  onClose: () => void;
  refetch: (refetch?: boolean) => Promise<void>;
}

const Announcement: React.FC<AnnouncementProps> = ({
  isNotificationsOpen,
  toggleNotifications,
  unReadCount,
  onClose,
  refetch,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <div
        className={`nd-nav-link-container ${isNotificationsOpen ? "selected" : ""}`}
        onClick={toggleNotifications}
        data-notifications-toggle="true"
        style={{ position: "relative" }}
      >
        <div style={{ position: "relative" }}>
          <Bell className="nav-item-icon" />
          {unReadCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: -8,
                right: -8,
                background: "red",
                color: "white",
                borderRadius: "50%",
                width: "16px",
                height: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                fontWeight: "bold",
              }}
            >
              {unReadCount > 9 ? "9+" : unReadCount}
            </span>
          )}
        </div>
        <span
          className={`nd-nav-link-text ${isNotificationsOpen ? "selected" : ""}`}
        >
          Announcements
        </span>
        <span className="nav-item-descriptor">News & Updates</span>
        {isNotificationsOpen && <div className="nd-nav-link-indicator" />}
      </div>
      {isNotificationsOpen && (
        <NotificationsMenu
          refetch={refetch}
          isOpen={isNotificationsOpen}
          onClose={onClose}
        />
      )}
    </div>
  );
};

export default Announcement;
